import * as React from "react";
import { SecurityType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { InvestmentAssetClassAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentAssetClassAllocationModel";
import { ICombineTableConfig, ITableConfig, Table } from "../../../../../../../Shared/Table/Table";

interface IAssetAllocationTableProps {
    data: InvestmentAssetClassAllocationModel;
    isHeadAccount?: boolean;
}

export const AssetAllocationTable = (props: IAssetAllocationTableProps) => {
    const res = props.data;
    const header = res.AssetClassAllocationSummary;
    let content = res.InvestmentAssetClassAllocations;
    let tableConfig: ITableConfig[] = [
        {
            title: "Investments",
            key: "InvestmentName",
            render: (data, row, index) => {
                return row.SecurityType == SecurityType.Cash || row.FinexDocumentUrl == "" ? (
                    data
                ) : (
                    <a className="hyperlink" target="_blank" href={row.FinexDocumentUrl}>
                        {data}
                    </a>
                );
            },
        },
    ];
    tableConfig = tableConfig.concat(
        header.map((ele) => {
            return {
                title: ele.DisplayName,
                key: ele.ClassCode,
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
            };
        })
    );
    tableConfig.push({ title: "Total", key: "total", thCssWrapper: "cell-right", tdCssWrapper: "cell-right" });
    const cash = content.filter((ele) => ele.InvestmentName == "GBP Cash")[0];
    if (cash) {
        content = content
            .sort(function (a, b) {
                if (a.InvestmentName < b.InvestmentName) {
                    return -1;
                }
                if (a.InvestmentName > b.InvestmentName) {
                    return 1;
                }
                return 0;
            })
            .filter((ele) => ele.InvestmentName !== "GBP Cash");
        content.push(cash);
    }
    const data = content.map((ele) => {
        const row = { InvestmentName: ele.InvestmentName, FinexDocumentUrl: ele.FinexDocumentUrl };
        row["total"] = ele.AssetClassAllocations.reduce((total, cur) => {
            return total + cur.Weight;
        }, 0);
        row["total"] = row["total"].toFixed(2).toString() + "%";
        header.forEach((col) => {
            const value = ele.AssetClassAllocations.filter((item) => item.ClassCode == col.ClassCode)[0];
            row[col.ClassCode] = value ? value.Weight.toFixed(2).toString() + "%" : "-";
        });

        return row;
    });

    let footer: ICombineTableConfig[] = [
        { data: `${props.isHeadAccount ? "Portfolio" : "Sub-account"} Total`, tfTdCssWrapper: "cell-right" },
    ];

    footer = footer.concat(
        header.map((ele, i) => {
            return { data: ele.Allocation.toFixed(2).toString() + "%", tfTdCssWrapper: "cell-right" };
        })
    );
    footer.push({
        data:
            header
                .reduce((total, current) => {
                    return total + current.Allocation;
                }, 0)
                .toFixed(2) + "%",
        tfTdCssWrapper: "cell-right",
    });
    tableConfig = tableConfig.filter((ele) => ele.title !== "no need");

    return (
        <div>
            <Table col={tableConfig} data={data} TotalBody={footer} />
        </div>
    );
};
